export interface IAddToPoErrorMapping {
  message: string;
  clearSelectedPo: boolean;
}

/**
 * The app-wide axios instance uses a custom `transformResponse` (see
 * services/http.ts:139) that returns the raw response body as a string
 * instead of auto-parsing JSON. So on HTTP errors, `error.response.data`
 * can be either:
 *   - the parsed object  { code, message }   (normal axios default)
 *   - the raw JSON string '{"code":"...","message":"..."}'  (this project)
 *   - a non-JSON string  (server returned plain text)
 * Normalise both cases before reading fields.
 */
function parseResponseBody(raw: any): any {
  if (raw == null) return undefined;
  if (typeof raw === 'object') return raw;
  if (typeof raw !== 'string') return undefined;
  try {
    return JSON.parse(raw);
  } catch {
    return { message: raw };
  }
}

export function mapAddToPoError(e: any): IAddToPoErrorMapping {
  const status = e?.response?.status;
  const body = parseResponseBody(e?.response?.data);
  const code = body?.code;
  const serverMessage = body?.message;

  if (status === 409 && code === 'not_a_draft') {
    return {
      message: serverMessage
        || 'That PO is no longer a draft. Pick another.',
      clearSelectedPo: true,
    };
  }
  if (status === 409 && code === 'already_in_po') {
    return {
      message: serverMessage
        || 'This product is already on the selected purchase order.',
      clearSelectedPo: false,
    };
  }
  if (status === 404) {
    return {
      message: serverMessage
        || 'That purchase order is no longer available.',
      clearSelectedPo: true,
    };
  }
  return {
    message: serverMessage || e?.message || 'Something went wrong.',
    clearSelectedPo: false,
  };
}
